import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ActionType = 'create' | 'edit' | 'createSku' | 'createPhone' | 'editStep' | 'custom' | null;

type InitialStateType = {
  title: string;
  actionBtn: ActionType;
  actionDrawer: ActionType;
  actionBtnTitle: string;
  isDrawerOpen: boolean;
  drawerName: string;
};

const initialState: InitialStateType = {
  title: '',
  actionBtn: null,
  actionBtnTitle: '',
  drawerName: '',
  actionDrawer: null,
  isDrawerOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setHeaderTitle(state, action: PayloadAction<string>) {
      state.title = action.payload;
    },
    setHeaderAction(state, action: PayloadAction<ActionType>) {
      state.actionBtn = action.payload;
    },
    setDrawerOpen(state, action: PayloadAction<boolean>) {
      state.isDrawerOpen = action.payload;
    },
    setDrawerAction(state, action: PayloadAction<ActionType>) {
      state.actionDrawer = action.payload;
    },
    setActionBtnTitle(state, action: PayloadAction<string>) {
      state.actionBtnTitle = action.payload;
    },
    setDrawerName(state, action: PayloadAction<string>) {
      state.drawerName = action.payload;
    },
  },
});

export const { setHeaderTitle, setHeaderAction, setDrawerOpen, setDrawerAction, setActionBtnTitle, setDrawerName } =
  uiSlice.actions;

export default uiSlice.reducer;
